import React, { useEffect } from 'react';
import {
  Form, Input, Button, notification,
} from 'antd';
import { useMutation } from '@apollo/client';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { COMPLETE_FORGET_PASSWORD } from '../../graphql';
import DecoCenter from '../../components/DecoCenter';
import { LOGIN } from '../../routes';

const { Item: FormItem } = Form;
const CompleteForgetPassword = () => {
  const [completeForgetPassword, { loading, data }] = useMutation(COMPLETE_FORGET_PASSWORD);
  const { search } = useLocation();
  const navigate = useNavigate();
  // The reset token names its own subject, so no email travels with it —
  // the previous flow took one and acted on whichever account it named.
  const token = new URLSearchParams(search).get('token');
  const handleFormSubmit = async (formInput) => {
    const { newPassword } = formInput;
    const input = { newPassword, token };
    try {
      await completeForgetPassword({ variables: { input } });
    } catch (error) {
      notification.error({
        message: 'Action not allowed',
        description: error.message || 'Cannot create new password, invalid request',
      });
    }
  };
  useEffect(() => {
    if (!loading && data) {
      notification.success({ message: 'Password changed successfully', description: 'Please proceed to login using your new password' });
      navigate(LOGIN);
    }
  }, [loading, data, navigate]);

  if (!token) {
    return <Navigate to={LOGIN} replace />;
  }
  return (
    <DecoCenter>
      <Form layout="vertical" requiredMark={false} onFinish={handleFormSubmit} name="forget_password" className="form-wrapper">
        <div className="gx-login-text">
          <h3 className="gx-m-4 gx-fs-xl">New Password</h3>
        </div>
        <FormItem name="newPassword" className="input-field" label="New password" rules={[{ required: true, min: 6, message: 'Please provide a valid password' }]}>
          <Input.Password type="password" placeholder="choose a new password" />
        </FormItem>
        <FormItem
          name="comfirmPassword"
          className="input-field"
          label="Confirm password"
          dependencies={['newPassword']}
          rules={[{ required: true, message: 'new password should match confirm password' }, ({ getFieldValue }) => ({
            validator(_rule, value) {
              if (!value || getFieldValue('newPassword') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject('password mismatch!');
            },
          })]}
        >
          <Input.Password placeholder="confirm password" />
        </FormItem>
        <Form.Item className="input-field">
          <Button loading={loading} htmlType="submit" size="large" type="primary" className="gx-w-100">
            {loading ? 'Loading' : 'Confirm'}
          </Button>
        </Form.Item>
      </Form>
    </DecoCenter>
  );
};

export default CompleteForgetPassword;
